<!-- Pre-Fab Controller Section good to go -->
<div class="container-fluid"
    *ngIf="isAutomationElectricalMechanical">
    <fieldset class="border rounded-3 p-1 fieldsetFontSize" *ngIf="preFabControllerFormGroup && costReviewPreFab?.isPrefabControllerVisible"
        [formGroup]="preFabControllerFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('preFabControllerFormGroup')" trackChanges>
        <legend class="float-none w-auto    font-size-13">
            {{'REVIEW_SOL_CHECKLIST_TAB.PRE_FAB_CONTROLLER.TITLE' |translate}}</legend>
        <div class="row">
            <div class="col-sm-6">
                <div class="row bottomPadding">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.PRE_FAB_CONTROLLER.PRE_FAB_CONTROLLER_USED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-8">
                        {{ costReviewPreFab?.prefabControllerUsed }}
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="costReviewPreFab?.isReasonForExceptionVisible">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.PRE_FAB_CONTROLLER.REASON_FOR_EXCEPTION' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-8">
                        <si-combo-box [inputValue]="costReviewPreFab?.reasonForException" [dropDownList]="reasonsForExceptionDropDownData"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                            (inputValueChange)="onPrefabReasonForExceptionChange($event)">
                        </si-combo-box>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</div>

<!-- Building Level Network Panels Section good to go -->

<div class="row m-0">
    <div class="col-sm-12 p-0"
        *ngIf="isAutomationElectricalMechanical">
        <div class="container-fluid h-100">
            @if(buildingLevelNetworkPanelsFormGroup)
            {
                <fieldset class="border rounded-3 p-1 h-100"
                [formGroup]="buildingLevelNetworkPanelsFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('buildingLevelNetworkPanelsFormGroup')" trackChanges>
                <legend class="float-none w-auto     font-size-13">
                    @if (optionalWorkflowCondition) {
                    <si-check-box [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('buildingLevelNetworkPanelsFormGroup')" 
                    (change)="onSectionToggle('buildingLevelNetworkPanelsFormGroup', $event)"></si-check-box>
                    }
                    {{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.TITLE'|translate}}
                </legend>
                <div class="row w-50">
                    <div class="col-sm-12">
                        <div class="row bottomPadding" *ngIf=" isSalePriceGreaterThan150">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.NUMBER_OF_BUILDING_LEVEL_NETWORKS'|translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <app-si-form-field formControlName="numberOfBuildingLevelNetworks" [type]="'number'" [maxlength]="2" [max]="99"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.FIELD_PANEL_PRODUCT_NAME'|translate}}</mat-label>
                            </div>
                            <div class="col-sm-6 break-word">
                                <app-si-form-field formControlName="fieldPanelProductName" [maxlength]="40" 
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.NUMBER_OF_FIELD_PANEL_DRIVERS'|translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <app-si-form-field formControlName="numberOfFieldPanelDrivers" [type]="'number'" [maxlength]="3" [max]="999"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.EQUIPMENT_MANAGED_BY_FIELD_PANEL_DRIVERS'|translate}}</mat-label>
                            </div>
                            <div class="col-sm-6 break-word">
                                <app-si-form-field formControlName="equipmentManagedByPanelDrivers" [maxlength]="40" 
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.SPACE_PANEL_CAPACITY'|translate}} (%)</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <app-si-form-field formControlName="sparePanelCapacity" [type]="'percent'"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                            </div>
                        </div>
                        @if(isSalePriceGreaterThan150){
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.NETWORK_BY'|translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns" formControlName="networkBy"
                                    [disabled]="false">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(buildingLevelNetworkPanelsFormGroup, 'networkBy')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'CUSTOMER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(buildingLevelNetworkPanelsFormGroup, 'networkBy')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        }
                        <div class="row bottomPadding" *ngIf=" isSalePriceGreaterThan150">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.NETWORK_HARDWARE_INCLUDED'|translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns"
                                    formControlName="networkHardwareIncluded" [disabled]="false">
                                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(buildingLevelNetworkPanelsFormGroup, 'networkHardwareIncluded')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(buildingLevelNetworkPanelsFormGroup, 'networkHardwareIncluded')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row bottomPadding" *ngIf=" isSalePriceGreaterThan150">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.NETWORK_SPECIFICATIONS_REVIEWED'|translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns"
                                    formControlName="networkSpecificationsReviewed" [disabled]="false">
                                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(buildingLevelNetworkPanelsFormGroup, 'networkSpecificationsReviewed')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(buildingLevelNetworkPanelsFormGroup, 'networkSpecificationsReviewed')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>

                        </div>
                        <div class="row bottomPadding" *ngIf=" isSalePriceGreaterThan150">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.BUILDING_LEVEL_NETWORK_PANELS.FIBER_OPTICS_REQUIRED'|translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns" formControlName="fiberOpticsRequired"
                                    [disabled]="false">
                                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(buildingLevelNetworkPanelsFormGroup, 'fiberOpticsRequired')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(buildingLevelNetworkPanelsFormGroup, 'fiberOpticsRequired')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                </div>
                </fieldset>
            }
        </div>
    </div>
    

    <!-- System Attributes Section (Fire) -->
    <div class="col-sm-6 ps-3 pe-0" *ngIf="business === constants.BUSINESS_FIRE">
        <div class="container-fluid h-100">
            <fieldset class="border rounded-3 p-1 h-100" *ngIf="systemAttributesFormGroup"
                [formGroup]="systemAttributesFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('systemAttributesFormGroup')" trackChanges>
                <legend class="float-none w-auto font-size-13">
                    @if (optionalWorkflowCondition) {
                        <si-check-box [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('systemAttributesFormGroup')" 
                        (change)="onSectionToggle('systemAttributesFormGroup', $event)"></si-check-box>
                    }
                    {{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_ATTRIBUTES.TITLE'|translate}}
                </legend>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_ATTRIBUTES.INSTALL_TYPE'|translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="installType">
                            <si-radio-button [displayText]="'TURNKEY' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemAttributesFormGroup, 'installType')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'PARTS_AND_SMARTS' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemAttributesFormGroup, 'installType')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_ATTRIBUTES.SYSTEM_TYPE'|translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-column" formControlName="systemType">
                            <div class="row">
                                <div class="d-flex flex-row radio-group radio-btns">
                                    <si-radio-button [displayText]="'NEW' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemAttributesFormGroup, 'systemType')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'RETROFIT' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemAttributesFormGroup, 'systemType')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="d-flex flex-row radio-group radio-btns">
                                    <si-radio-button [displayText]="'NEW_RETROFIT' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemAttributesFormGroup, 'systemType')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'EXPANSION' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemAttributesFormGroup, 'systemType')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_ATTRIBUTES.ADDITIONAL_SYSTEMS'|translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <si-check-box-group
                            [options]="additionalSystemsOptions"
                            [isReadMode]="isReadOnlyMode"
                            [isDisabled]="isDisabled"
                            formControlName="additionalSystems"
                            [columnsPerRow]="1">
                        </si-check-box-group>
                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1" *ngIf="isSystemAttributesNotApplicableReadOnly">
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_ATTRIBUTES.TITLE'|translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>

<!-- System Configuration and Retrofit Considerations good to go -->
<div class="row" *ngIf="business === constants.BUSINESS_FIRE">
    <div class="col-sm-6 pe-0">
        <div class="container-fluid h-100">
            <fieldset class="border rounded-3 p-1 h-100"
                *ngIf="systemConfigurationFormGroup"
                [formGroup]="systemConfigurationFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('systemConfigurationFormGroup')" trackChanges>
                <legend class="float-none w-auto font-size-13">
                     @if (optionalWorkflowCondition) {
                    <si-check-box [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('systemConfigurationFormGroup')" 
                    (change)="onSectionToggle('systemConfigurationFormGroup', $event)"></si-check-box>
                    }
                    {{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.TITLE' | translate}} </legend>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.DESIGO_PANELS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <div class="three-checkbox-container">
                        <si-check-box-group
                            [options]="desigoPanelsOptions"
                            [isReadMode]="isReadOnlyMode"
                            [isDisabled]="isDisabled"
                            formControlName="desigoPanels"
                            [columnsPerRow]="3">
                        </si-check-box-group>
                        </div>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.VOICE_SYSTEM' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="voiceSystem"
                            [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'voiceSystem')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'voiceSystem')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.GLOBAL_VOICE' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="globalVoice"
                            [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'globalVoice')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'globalVoice')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.BACKUP_AMPS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <div class="aligned-options-container">
                        <si-check-box-group
                            [options]="backupAmpsOptions"
                            [isReadMode]="isReadOnlyMode"
                            [isDisabled]="isDisabled"
                            formControlName="backupAmps"
                            [columnsPerRow]="2">
                        </si-check-box-group>
                        </div>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.BATTERY_BACKUP' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <si-drop-down
                            [inputValue]="formControlsValueForString(systemConfigurationFormGroup,'batteryBackup')"
                            (inputValueChange)="setFormControlValue(systemConfigurationFormGroup, 'batteryBackup', $event)"
                            [isReadMode]="isReadOnlyMode" [dropDownList]="batteryBackupList" [isDisabled]="isDisabled">
                        </si-drop-down>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.NAC_WIRING' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="nacWiring"
                            [disabled]="false">
                            <si-radio-button [displayText]="'CLASS_A' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'nacWiring')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'CLASS_B' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'nacWiring')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.IDC_WIRING' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="idcWiring"
                            [disabled]="false">
                            <si-radio-button [displayText]="'CLASS_A' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'idcWiring')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'CLASS_B' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'idcWiring')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.SLC_WIRING' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group three-radio-btn radio-btns" formControlName="slcWiring"
                            [disabled]="false">
                            <si-radio-button [displayText]="'CLASS_A' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'slcWiring')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'CLASS_B' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'slcWiring')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'CLASS_X' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'slcWiring')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.PROPOSED_SYSTEM_MEETS_SPECS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="proposedSystem"
                            [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'proposedSystem')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'proposedSystem')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.DIALER_PROVIDED_BY_SIEMENS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="dialerProvidedBySiemens" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'dialerProvidedBySiemens')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'dialerProvidedBySiemens')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6 align-items-baseline mt-3">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.COMMUNICATION_METHOD' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-column" formControlName="communicationMethod"
                            [disabled]="false">
                            <div class="row">
                                <div class="d-flex flex-row radio-group radio-btns">
                                    <si-radio-button [displayText]="'COMMUNICATION_METHOD_POTS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'communicationMethod')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'COMMUNICATION_METHOD_CELLULAR' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'communicationMethod')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="d-flex flex-row radio-group radio-btns">
                                    <si-radio-button [displayText]="'COMMUNICATION_METHOD_IP' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'communicationMethod')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'COMMUNICATION_METHOD_RF_AES_MESH_MORACO' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'communicationMethod')"
                                        [isDisabled]="isDisabled">
                                    </si-radio-button>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.MXLV_TO_DESIGO_FSM_MIGRATION' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="mxlvDesigoFsmMigration" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'mxlvDesigoFsmMigration')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'mxlvDesigoFsmMigration')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row ps-3 pe-3">
                    <fieldset class="border rounded-3 p-1">
                        <legend class="float-none w-auto     font-size-13">
                            {{'REVIEW_SOL_CHECKLIST_TAB.NETWORK.TITLE' | translate}}</legend>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.NETWORK.NUMBER_OF_NODES' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <app-si-form-field formControlName="numberOfNodes" [type]="'number'" [maxlength]="3" [max]="999"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                            </div>
                        </div>
                        <div class="row bottomPadding"
                            *ngIf="costReviewSystemConfiguration.numberOfNodes >= constants.ZERO">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.NETWORK.NETWORK_STYLE' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="networkStyle"
                                    [disabled]="false">
                                    <si-radio-button [displayText]="'NETWORK_STYLE_PEER_TO_PEER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'networkStyle')"
                                        [isDisabled]="isNetworkConfigurationDisabled">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'NETWORK_STYLE_TRANSPONDER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(systemConfigurationFormGroup, 'networkStyle')"
                                        [isDisabled]="isNetworkConfigurationDisabled">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row bottomPadding"
                            *ngIf="costReviewSystemConfiguration.numberOfNodes >= constants.ZERO">
                            <div class="col-sm-6">
                            </div>
                            <div class="col-sm-6">
                                <div class="aligned-options-container">
                                <si-check-box-group
                                    [options]="networkOptionsArray"
                                    [isReadMode]="isReadOnlyMode"
                                    [isDisabled]="isNetworkConfigurationDisabled"
                                    formControlName="networkOptions"
                                    [columnsPerRow]="2">
                                </si-check-box-group>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>

            </fieldset>
            <fieldset class="border rounded-3 p-1"
                *ngIf="!costReviewSystemConfiguration.isSystemConfigurationApplicable && isReadOnlyMode">
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_CONFIGURATION.TITLE' | translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
    <div class="col-sm-6 ps-0">
        <div class="container-fluid h-100">
            <fieldset class="border rounded-3 p-1 h-100"
                *ngIf="retrofitConsiderationsFormGroup"
                [formGroup]="retrofitConsiderationsFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('retrofitConsiderationsFormGroup')" trackChanges>
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('retrofitConsiderationsFormGroup')" (change)="onSectionToggle('retrofitConsiderationsFormGroup', $event)"></si-check-box></legend>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.SYSTEM_COMPONENT_REUSE' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="systemComponentReuse" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'systemComponentReuse')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'systemComponentReuse')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.EXCEPTIONS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 mb-3">
                        <si-text-area formControlName="exceptions"
                            [isReadMode]="isReadOnlyMode"></si-text-area>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.EXISTING_SYSTEM_MANUFACTURER'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="existingSystemManufacturer" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.EXISTING_SYSTEM_MODEL' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="existingSystemModel" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.EXISTING_SYSTEM_OPERATIONAL_DURING_RETROFIT'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="operationalDuringRetrofit" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'operationalDuringRetrofit')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'operationalDuringRetrofit')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.SUFFICIENT_SPACE_TO_MOUNT_NEW_ENCLOSURES'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="sufficientSpaceToMount" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'sufficientSpaceToMount')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'sufficientSpaceToMount')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.CONDITIONS_VERIFIED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="conditionsVerified" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'conditionsVerified')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'conditionsVerified')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.EXISTING_WIRING_REUSED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="existingWiringReused" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'existingWiringReused')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'existingWiringReused')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10 ps-5">{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.SUBCONTRACTOR_AWARE'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="subcontractorIsAware" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || !isExistingWiringReused" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'subcontractorIsAware')"></si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || !isExistingWiringReused" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'subcontractorIsAware')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10 ps-5">{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.WIRING_COMPATIBLE_WITH_NEW_SYSTEM'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="wiringIsCompatible" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || !isExistingWiringReused" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'wiringIsCompatible')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || !isExistingWiringReused" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'wiringIsCompatible')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10 ps-5">{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.CONDUIT_OR_RACEAWAY_REUSE'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="conduitOrRacewayReuse" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || !isExistingWiringReused" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'conduitOrRacewayReuse')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || !isExistingWiringReused" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'conduitOrRacewayReuse')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.FIRE_WATCH_REQUIRED' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="fireWatchRequired" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'fireWatchRequired')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'fireWatchRequired')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.RESPONSIBLE_FOR_COMPONENT_AND_WIRING_TESTING' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="responsibleForComponent" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'responsibleForComponent')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(retrofitConsiderationsFormGroup, 'responsibleForComponent')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1"
                *ngIf="!costReviewRetrofitConsiderations.isRetrofitConsiderationsApplicable && isReadOnlyMode">
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.RETROFIT_CONSIDERATIONS.TITLE' |translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>

<!-- Operator Workstation and Software and Chiller plant good to go -->
<div class="row">
    <div class="col-sm-6 pe-0">
        <div class="container-fluid h-100">
        @if(operatorWorkstationFormGroup)
        {
            <fieldset class="border rounded-3 p-1 fieldsetFontSize h-100"
                [formGroup]="operatorWorkstationFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('operatorWorkstationFormGroup')" trackChanges>
                <legend class="float-none w-auto     font-size-13">
                    @if (business === constants.BUSINESS_FIRE){
                        {{'OPERATOR_WORKSTATION_DESIGO_CC' |translate}}
                    }
                    @else {
                        {{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.TITLE' |translate}}
                    }
                    <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('operatorWorkstationFormGroup')" (change)="onSectionToggle('operatorWorkstationFormGroup', $event)"></si-check-box>
                </legend>
                <div class="row bottomPadding"
                    *ngIf="isNotSecurity">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.NUMBER_OF_SERVERS'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfServers" [type]="'number'" [maxlength]="2" [max]="99"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isNotSecurity">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.NUMBER_OF_WORKSTATIONS'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfWorkstations" [type]="'number'" [maxlength]="2" [max]="99"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isNotSecurity">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.NUMBER_OF_CLIENTS'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfClients" [type]="'number'" [maxlength]="2" [max]="99"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isNotSecurity">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.COMPETITOR_SYSTEM'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="competitorSystem" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isAutomationElectricalFireMechanical">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.INTERNET_ACCESSIBLE'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="internetAccessible" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(operatorWorkstationFormGroup, 'internetAccessible')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(operatorWorkstationFormGroup, 'internetAccessible')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isAutomationElectricalFireMechanical">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.FEATURES_REQUIRED'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="featuresRequired" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isAutomationElectricalMechanical">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.APT_UTILIZED'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="aptUtilized"
                            [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(operatorWorkstationFormGroup, 'aptUtilized')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(operatorWorkstationFormGroup, 'aptUtilized')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isAutomationElectricalMechanical">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.NUMBER_OF_PROGRAMS'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfPrograms" [type]="'number'" [maxlength]="2" [max]="99"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isNotSecurity">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.NUMBER_OF_GRAPHICS'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfGraphics" [type]="'number'" [maxlength]="3" [max]="999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isAutomationElectricalFireMechanical">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.CENTRALIZED_GRAPHICS_UTILIZED'
                            |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="centralizedGraphicsUtilized" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(operatorWorkstationFormGroup, 'centralizedGraphicsUtilized')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(operatorWorkstationFormGroup, 'centralizedGraphicsUtilized')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding"
                    *ngIf="isAutomationElectricalFireMechanical">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.GECC_UTILIZED'
                            |translate}} </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="geccUtilized"
                            [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(operatorWorkstationFormGroup, 'geccUtilized')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(operatorWorkstationFormGroup, 'geccUtilized')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="col-sm-12">
                    <fieldset class="border rounded-3 p-1">
                        <legend class="float-none w-auto     font-size-13">
                            {{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.NETWORK_REQUIREMENTS'
                            |translate}} </legend>
                        <div class="row bottomPadding"
                            *ngIf="isAutomationElectricalFireMechanical">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.PROTOCOLS'
                                    |translate}} </mat-label>
                            </div>
                            <div class="col-sm-6">
                                <div class="aligned-options-container">
                                <si-check-box-group
                                    [options]="operatorProtocolOptions"
                                    [isReadMode]="isReadOnlyMode"
                                    [isDisabled]="isDisabled"
                                    formControlName="protocols"
                                    [columnsPerRow]="2">
                                </si-check-box-group>
                                </div>
                            </div>
                        </div>
                        <div class="row bottomPadding"
                            *ngIf="isAutomationElectricalFireMechanical">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.NUMBER_OF_SWITCHES_HUBS'
                                    |translate}} </mat-label>
                            </div>
                            <div class="col-sm-6">
                                <app-si-form-field formControlName="numberOfSwitches" [type]="'number'" [maxlength]="isFire ? 4 : 3" [max]="isFire ? 9999 : 999"
                                    [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </fieldset>
        }
        @if(isOperatorWorkstationNotApplicableAndNotSecurity && isReadOnlyMode)
        {
            <fieldset class="border rounded-3 p-1">
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.OPERATOR_WORKSTATION_AND_SOFTWARE.TITLE' |translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        }
        </div>
    </div>
    <div class="col-sm-6 ps-0"
        *ngIf="isAutomationElectricalMechanical">
        <div class="container-fluid h-100">
            <fieldset class="border rounded-3 p-1 h-100" *ngIf="chillerPlantFormGroup"
                [formGroup]="chillerPlantFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('chillerPlantFormGroup')" trackChanges>
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.TITLE'| translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('chillerPlantFormGroup')" (change)="onSectionToggle('chillerPlantFormGroup', $event)"></si-check-box></legend>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.NUMBER_OF_CHILLERS' | translate}}
                        </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfChillers" [type]="'number'" [maxlength]="2" [max]="99"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerChillers" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.DRIVERS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10"
                            formControlName="driversChiller">
                            <si-radio-button [displayText]="'HARD_WIRED' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'driversChiller')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'INTEGRATION' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'driversChiller')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.CHILLERS_CONTROLS_FURNISHED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="chillersControlsFurnishedBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'chillersControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'chillersControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.CHILLERS_CONTYROLS_INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="chillersControlsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'chillersControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'chillersControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.CHILLERS_CONTROLS_WIRED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="chillersControlsWiredBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'chillersControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'chillersControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfChillers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.NUMBER_OF_TOWERS' | translate}}
                        </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfTowers" [type]="'number'" [maxlength]="2" [max]="99"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerTowers" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.DRIVERS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10"
                            formControlName="driversTowers">
                            <si-radio-button [displayText]="'HARD_WIRED' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'driversTowers')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'INTEGRATION' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'driversTowers')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.TOWERS_CONTROLS_FURNISHED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="towersControlsFurnishedBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'towersControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'towersControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.TOWERS_CONTROLS_INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="towersControlsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'towersControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'towersControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.TOWERS_CONTROLS_WIRED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="towersControlsWiredBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'towersControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'towersControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.NUMBER_OF_PUMPS' | translate}}
                        </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfPumps" [type]="'number'" [maxlength]="3" [max]="999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerPumps" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.DRIVERS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10"
                            formControlName="driversPumps">
                            <si-radio-button [displayText]="'HARD_WIRED' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'driversPumps')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'INTEGRATION' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'driversPumps')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.PUMPS_AND_SENSORS_FURNISHED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="pumpsSensorsFurnishedBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'pumpsSensorsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'pumpsSensorsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.PUMPS_AND_SENSORS_INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="pumpsSensorsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'pumpsSensorsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'pumpsSensorsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.PUMPS_AND_SENSORS_WIRED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="pumpsSensorsWiredBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'pumpsSensorsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(chillerPlantFormGroup, 'pumpsSensorsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['chillerPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1" *ngIf="!costReviewChillerPlant?.isChillerPlantApplicable && isReadOnlyMode">
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.CHILLER_PLANT.TITLE'| translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>

<!-- Heating plant , FLN and Terminal controller-->
<div class="row"
    *ngIf="isAutomationElectricalMechanical">
    <div class="col-sm-6 pe-0">
        <div class="container-fluid h-100">
            <fieldset class="border rounded-3 p-1 h-100" *ngIf="heatingPlantFormGroup"
                [formGroup]="heatingPlantFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('heatingPlantFormGroup')" trackChanges>
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('heatingPlantFormGroup')" (change)="onSectionToggle('heatingPlantFormGroup', $event)"></si-check-box></legend>

                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.NUMBER_OF_BOILERS' | translate}}
                        </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfBoilers" [type]="'number'" [maxlength]="3" [max]="999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerBoilers" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.DRIVERS' |
                            translate}} </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10"
                            formControlName="driversBoilers">
                            <si-radio-button [displayText]="'HARD_WIRED' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'driversBoilers')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'INTEGRATED' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'driversBoilers')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.BOILERS_AND_CONTROLS_FURNISHED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="boilersControlsFurnishedBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'boilersControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'boilersControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.BOILERS_AND_CONTROLS_INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="boilersControlsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'boilersControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'boilersControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.BOILERS_AND_CONTROLS_WIRED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="boilersControlsWiredBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'boilersControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'boilersControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfBoilers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <!-- Furnished / Installed / Wired (Boilers) unchanged (already app-si-form-field) -->
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.NUMBER_OF_TOWERS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfTowers" [type]="'number'" [maxlength]="2" [max]="99"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerTowers" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']">
                        </app-si-form-field>
                    </div>
                </div>
                <!-- Drivers towers unchanged -->
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.DRIVERS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                         <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10"
                            formControlName="driversTowers">
                            <si-radio-button [displayText]="'HARD_WIRED' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'driversTowers')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'INTEGRATION' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'driversTowers')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.TOWERS_AND_CONTROLS_FURNISHED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="towersControlsFurnishedBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'towersControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'towersControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.TOWERS_AND_CONTROLS_INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="towersControlsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'towersControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'towersControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.TOWERS_AND_CONTROLS_WIRED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="towersControlsWiredBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'towersControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'towersControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfTowers']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.NUMBER_OF_PUMPS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfPumps" [type]="'number'" [maxlength]="3" [max]="999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerPumps" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.DRIVERS' |
                            translate}} </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row margin-top-10"
                            formControlName="driversPumps">
                            <si-radio-button [displayText]="'HARD_WIRED' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'driversPumps')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'INTEGRATION' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'driversPumps')">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.PUMPS_AND_SENSORS_FURNISHED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="pumpsSensorsFurnishedBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'pumpsSensorsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'pumpsSensorsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.PUMPS_AND_SENSORS_INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="pumpsSensorsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'pumpsSensorsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'pumpsSensorsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.PUMPS_AND_SENSORS_WIRED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="pumpsSensorsWiredBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'pumpsSensorsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(heatingPlantFormGroup, 'pumpsSensorsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['heatingPlantFormGroup.numberOfPumps']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1" *ngIf="!costReviewHeatingPlant?.isHeatingPlantApplicable && isReadOnlyMode">
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.HEATING_PLANT.TITLE' | translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
    <div class="col-sm-6 ps-0 column pt-3 container-fluid">
        <div class="col-sm-12 container-fluid" *ngIf="isSalePriceGreaterThan150">
            <fieldset class="border rounded-3 p-1 h-100 mb-0" [formGroup]="flnFormGroup" trackChanges *ngIf="flnFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('flnFormGroup')">
                <legend class="float-none w-auto     font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.FLN.TITLE'
                    | translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.FLN.NUMBER_OF_VFDS' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfVfds" [type]="'number'" [maxlength]="3" [max]="999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.FLN.PRODUCT_NAME' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="productName" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.FLN.OTHER_FLN_MSTP_DEVICES' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="otherFlnMstpDevices" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.FLN.NETWORK_TYPE' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <div class="aligned-options-container">
                        <si-check-box-group
                            [options]="flnNetworkTypeOptions"
                            [isReadMode]="isReadOnlyMode"
                            [isDisabled]="isDisabled"
                            formControlName="networkType"
                            [singleRow]="true" [columnsPerRow]="2">
                        </si-check-box-group>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="col-sm-12 container-fluid">
            <fieldset class="border rounded-3 p-1 h-100 mb-0"
                *ngIf="terminalControllersFormGroup"
                [formGroup]="terminalControllersFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('terminalControllersFormGroup')" trackChanges>
                <legend class="float-none w-auto     font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('terminalControllersFormGroup')" (change)="onSectionToggle('terminalControllersFormGroup', $event)"></si-check-box></legend>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.CONTROLLER_TYPE' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <div class="aligned-options-container">
                            <si-check-box-group
                            [options]="terminalControllerTypeOptions"
                            [isReadMode]="isReadOnlyMode"
                            [isDisabled]="isDisabled"
                            formControlName="controllerType"
                            [singleRow]="true" [columnsPerRow]="2">
                            </si-check-box-group>
                        </div>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.NUMBER_OF_TERMINAL_UNITS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfTerminalUnits" [type]="'number'" [maxlength]="5" [max]="99999"  [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.NUMBER_OF_VAVS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfVavs" [type]="'number'" [maxlength]="5" [max]="99999"  [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerVavs" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfVavs']"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.CUSTOM_APPLICATIONS_REQUIRED'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="customApplicationsRequired" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'customApplicationsRequired')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfVavs']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'customApplicationsRequired')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfVavs']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="vavsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'vavsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfVavs']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'vavsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfVavs']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.NUMBER_OF_FCUS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfFcus" [type]="'number'" [maxlength]="5" [max]="99999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerFcus" [maxlength]="40"  [isReadMode]="isReadOnlyMode" 
                        [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfFcus']">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="fcusInstalledBy" [disabled]="isReadOnlyMode">
                            <si-radio-button [displayText]="'FIELD' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'fcusInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfFcus']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'MANUFACTURER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'fcusInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfFcus']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.NUMBER_OF_UVS' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfUvs" [type]="'number'" [maxlength]="5" [max]="99999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                        </app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.MANUFACTURER_PRODUCT_NAME'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturerUvs" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.UNITS_AND_CONTROLS_FURNISHED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="unitsControlsFurnishedBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'unitsControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'unitsControlsFurnishedBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.UNITS_AND_INSTALLED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="unitsControlsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'unitsControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'unitsControlsInstalledBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.UNITS_CONTROLS_WIRED_BY'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="unitsControlsWiredBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'unitsControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'unitsControlsWiredBy')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.POWER' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="power" [disabled]="false">
                            <si-radio-button [displayText]="'POWER_TRUNK' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'power')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'LOCAL_POWER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'power')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                    <div class="col-sm-6">
                        <mat-label
                            class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.INSTALLING_PNEUMATIC_TUBING'
                            | translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="installingPneumaticTubing" [disabled]="false">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'installingPneumaticTubing')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(terminalControllersFormGroup, 'installingPneumaticTubing')"
                                [isDisabled]="isDisabled || childFieldDisabledState['terminalControllersFormGroup.numberOfUvs']">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1"
                *ngIf="!costReviewTerminalUnits?.isTerminalControllersApplicable && isReadOnlyMode">
                <legend class="float-none w-auto font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.TERMINAL_CONTROLLERS.TITLE' | translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>

<!--  LLab Equipment  VFD Control Valves AFMSs  -->

<div class="row"  *ngIf="isAEMWithHighSalePrice">
    <div class="col-sm-6">
        <fieldset class="border rounded-3 p-1   " *ngIf="labEquipmentFormGroup"
            [formGroup]="labEquipmentFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('labEquipmentFormGroup')" trackChanges>
            <legend class="float-none w-auto font-size-13">
                {{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('labEquipmentFormGroup')" (change)="onSectionToggle('labEquipmentFormGroup', $event)"></si-check-box></legend>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.NUMBER_OF_TERMINAL_UNITS' |
                        translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <app-si-form-field formControlName="numberOfTerminalUnits" [type]="'number'" [maxlength]="5" [max]="99999"
                        [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </app-si-form-field>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.MANUFACTURER' |
                        translate}}</mat-label>
                </div>
                <div class="col-sm-6 break-word">
                    <app-si-form-field formControlName="manufacturer" [maxlength]="40" 
                        [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                    </app-si-form-field>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.AIR_VALVES_FURNISHED_BY' |
                        translate}} </mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="airValvesFurnishedBy" [disabled]="false">
                        <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'airValvesFurnishedBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                        <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'airValvesFurnishedBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.AIR_VALVES_INSTALLED_BY' |
                        translate}} </mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="airValvesInstalledBy" [disabled]="false">
                        <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'airValvesInstalledBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                        <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'airValvesInstalledBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.CONTROLS_FURNISHED_BY' |
                        translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="controlsFurnishedBy" [disabled]="false">
                        <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'controlsFurnishedBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                        <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'controlsFurnishedBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.CONTROLS_INSTALLED_BY' |
                        translate}} </mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="controlsInstalledBy" [disabled]="false">
                        <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'controlsInstalledBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                        <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'controlsInstalledBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.CONTROLS_WIRED_BY' |
                        translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="controlsWiredBy" [disabled]="false">
                        <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'controlsWiredBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                        <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'controlsWiredBy')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.NETWORK_TYPE' | translate}}
                    </mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="networkType" [disabled]="false">
                        <si-radio-button [displayText]="'ETHERNET' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'networkType')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                        <si-radio-button [displayText]="'MSTP' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'networkType')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.POWER' | translate}} </mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="power" [disabled]="false">
                        <si-radio-button [displayText]="'POWER_TRUNK' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'power')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                        <si-radio-button [displayText]="'LOCAL_POWER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(labEquipmentFormGroup, 'power')"
                            [isDisabled]="isDisabled">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </fieldset>
        <fieldset class="border rounded-3 p-1" *ngIf="!costReviewLabEquipment?.isLabEquipmentApplicable && isReadOnlyMode">
            <legend class="float-none w-auto font-size-13">
                {{'REVIEW_SOL_CHECKLIST_TAB.LAB_EQUIPMENT.TITLE' | translate}}</legend>
            <div class="row bottomPadding">
                <div class="col-sm-12">
                    <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="col-sm-6 ps-0">
        <div class="container-fluid h-100">
            <fieldset class="border rounded-3 p-1 h-100" *ngIf="vfdsFormGroup"
                [formGroup]="vfdsFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('vfdsFormGroup')" trackChanges>
                <legend class="float-none w-auto font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.VFDS.TITLE'
                    |translate}}  <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('vfdsFormGroup')" (change)="onSectionToggle('vfdsFormGroup', $event)"></si-check-box></legend>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.VFDS.NUMBER_OF_VFDS' |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <app-si-form-field formControlName="numberOfVfds" [type]="'number'" [maxlength]="3" [max]="999"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.VFDS.MANUFACTURER' |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="manufacturer" [maxlength]="40" 
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></app-si-form-field>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.VFDS.DRIVERS' |translate}} </mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="drivers" [disabled]="false">
                            <si-radio-button [displayText]="'HARD_WIRED' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(vfdsFormGroup, 'drivers')"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [displayText]="'INTEGRATION' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(vfdsFormGroup, 'drivers')"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.VFDS.UNITS_FURNISHED_BY' |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="unitsFurnishedBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(vfdsFormGroup, 'unitsFurnishedBy')"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(vfdsFormGroup, 'unitsFurnishedBy')"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.VFDS.UNITS_INSTALLED_BY' |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="unitsInstalledBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(vfdsFormGroup, 'unitsInstalledBy')"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(vfdsFormGroup, 'unitsInstalledBy')"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-6">
                        <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.VFDS.UNITS_WIRED_BY' |translate}}</mat-label>
                    </div>
                    <div class="col-sm-6">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="unitsWiredBy" [disabled]="false">
                            <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(vfdsFormGroup, 'unitsWiredBy')"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(vfdsFormGroup, 'unitsWiredBy')"
                                [isDisabled]="isDisabled">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1" *ngIf="!costReviewVFDS?.isVfdsApplicable && isReadOnlyMode">
                <legend class="float-none w-auto font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.VFDS.TITLE'
                    |translate}} </legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>


<div
    *ngIf=" ((business === constants.BUSINESS_AUTOMATION) || (business === constants.BUSINESS_ELECTRICAL) || (business === constants.BUSINESS_MECHANICAL))  && isSalePriceGreaterThan150">
    <div class="row">
        <div class="col-sm-6 pe-0">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100"
                    *ngIf="controlValvesFormGroup"
                    [formGroup]="controlValvesFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('controlValvesFormGroup')" trackChanges>
                    <legend class="float-none w-auto      font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.CONTROL_VALVES.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('controlValvesFormGroup')" (change)="onSectionToggle('controlValvesFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CONTROL_VALVES.NUMBER_OF_VALVES' | translate}}
                            </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfValves" [type]="'number'" [maxlength]="4" [max]="9999"  [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CONTROL_VALVES.MANUFACTURER' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="manufacturer" [maxlength]="40"  [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CONTROL_VALVES.APPLICATIONS' | translate}}
                            </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                            <si-check-box-group
                                [options]="controlValvesApplicationOptions"
                                [isReadMode]="isReadOnlyMode"
                                [isDisabled]="isDisabled"
                                formControlName="applications"
                                [singleRow]="true" [columnsPerRow]="2">
                            </si-check-box-group>
                            </div>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CONTROL_VALVES.UNITS_ACTUATORS_FURNISHED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsActuatorsFurnishedBy" [disabled]="false">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(controlValvesFormGroup, 'unitsActuatorsFurnishedBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(controlValvesFormGroup, 'unitsActuatorsFurnishedBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CONTROL_VALVES.UNITS_ACTUATORS_INSTALLED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsActuatorsInstalledBy" [disabled]="false">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(controlValvesFormGroup, 'unitsActuatorsInstalledBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(controlValvesFormGroup, 'unitsActuatorsInstalledBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.CONTROL_VALVES.UNITS_ACTUATORS_WIRED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsActuatorsWiredBy" [disabled]="false">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(controlValvesFormGroup, 'unitsActuatorsWiredBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(controlValvesFormGroup, 'unitsActuatorsWiredBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewControlValves?.isControlValvesApplicable && isReadOnlyMode">
                    <legend class="float-none w-auto font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.CONTROL_VALVES.TITLE' | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="col-sm-6 ps-0">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100" *ngIf="afmssFormGroup"
                    [formGroup]="afmssFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('afmssFormGroup')" trackChanges>
                    <legend class="float-none w-auto      font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('afmssFormGroup')" (change)="onSectionToggle('afmssFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.NUMBER_OF_AFMSS' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfAfms" [type]="'number'" [maxlength]="3" [max]="999"  [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.MANUFACTURER' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="manufacturer" [maxlength]="40"  [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.APPLICATIONS' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                            <si-check-box-group
                                [options]="afmssApplicationOptions"
                                [isReadMode]="isReadOnlyMode"
                                [isDisabled]="isDisabled"
                                formControlName="applications"
                                [singleRow]="true" [columnsPerRow]="2">
                            </si-check-box-group>
                            </div>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.AFMS_SCHEDULE' | translate}} </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="afmsSchedule" [disabled]="false">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(afmssFormGroup, 'afmsSchedule')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(afmssFormGroup, 'afmsSchedule')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.UNITS_DEVICES_FURNISHED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsDevicesFurnishedBy" [disabled]="false">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(afmssFormGroup, 'unitsDevicesFurnishedBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(afmssFormGroup, 'unitsDevicesFurnishedBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.UNITS_DEVICES_INSTALLED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsDevicesInstalledBy" [disabled]="false">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(afmssFormGroup, 'unitsDevicesInstalledBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(afmssFormGroup, 'unitsDevicesInstalledBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.UNITS_DEVICES_WIRED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsDevicesWiredBy" [disabled]="false">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(afmssFormGroup, 'unitsDevicesWiredBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadOnlyMode" [selectedValue]="formControlsValueForString(afmssFormGroup, 'unitsDevicesWiredBy')"
                                    [isDisabled]="isDisabled">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewAfmss?.isAfmsApplicable && isReadOnlyMode">
                    <legend class="float-none w-auto font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.AFMSS.TITLE' | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>

</div>








